/* セカサプ 注文フォーム（HulkApps の置き換え、2026-10 準備中）
 *
 * テーマの snippets/sekasapu-order-form.liquid が設定（組・本体の価格・追加商品の variant ID と価格）を
 * <script type="application/json" id="sof-config"> に書き、このファイルがフォームを組み立てて送信する。
 * 明細の決まりは shopify/orderForm.js（本体の行に欄の中身と _unit、オプション料金は「オプション：…」の隠れた商品）。
 * 送信は「本体（写真つき）を入れる → 追加商品をまとめて入れる → 失敗したら本体を取り消す」で、全部入るか全部入らないか。
 *
 * Node からは純粋関数（文言・表示条件・合計・入力チェック・明細の組み立て）だけを require してテストする。
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SekasapuOrderForm = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var FULL = '０１２３４５６７８９';
  var full = function (n) { return String(n).replace(/[0-9]/g, function (d) { return FULL[d]; }); };
  var yen = function (n) { return '¥' + Number(n || 0).toLocaleString('ja-JP'); };

  // 組（HulkApps の「発砲なし」「横幕（発砲無し」「発砲なし　急ぎなし」に当たる。発砲は廃止済み）
  var SETS = {
    standard: { bigPrint: false, banner: false, rush: true },
    bigprint: { bigPrint: true, banner: true, rush: true },
    norush: { bigPrint: false, banner: false, rush: false }
  };

  // 明細の項目名（shopify/orderForm.js の PROP と同じ。業者への発注文を作る処理がこの名前で読む）
  var PROP = {
    narration: '読み上げメッセージ',
    blackboard: '黒板に書くメッセージ',
    print: '写真プリントアウト',
    kiss: '写真キス',
    photo: function (n) { return '写真アップロード' + full(n); },
    bigPrint: '写真ビッグプリントアウト',
    banner: '横幕',
    bannerText: '横幕メッセージ',
    song: 'バースデーソング',
    music: '音楽指定',
    musicUrl: '音楽YouTube URL',
    musicStart: '音楽の開始タイム',
    voice: '機械音声読み上げ除去',
    rush: 'お急ぎ納品',
    nextDay: '翌日納品',
    editPack: '編集パック',
    sender: '差出人',
    editPackBand: '編集パックのひとこと',
    vertical: '縦長動画'
  };

  // 画面の文言（ここを直せば画面が変わる。料金は設定の追加商品の価格から出す）
  var TEXT = {
    // 2026-10-25: 入力の前に、基本料金に含まれるものと見本の動画の条件を 1 行で
    intro: '黒板のメッセージ・読み上げ・ダンス付き。オプションなしでも注文できます。見本の動画には、写真プリントなどのオプションが入っているものがあります。',
    examples: { label: '例文を見る', url: '/pages/celebration-message-examples' },
    blackboard: {
      label: '黒板に書くメッセージ（25文字まで）',
      help: '演者がこの文を黒板に書いて掲げます。記号は「！」「？」だけ使えます。',
      placeholder: '例）たかし 誕生日おめでとう！',
      max: 25
    },
    narration: {
      label: '読み上げメッセージ（ひらがな・40文字まで）',
      help: '動画の中で機械音声がこの文を読み、演者がまねして叫びます。ひらがなで書き、区切りたいところに空白を入れてください。',
      placeholder: '例）たかし たんじょうび おめでとう',
      max: 40
    },
    optionsHeading: 'オプション（追加料金）',
    print: { label: '写真プリント', unit: '1枚', help: '写真をプリントして、動画の中に登場させます。最大 5 枚。' },
    kiss: { label: 'プリントした写真に演者がキスをする' },
    photo: { label: function (n) { return n + '枚目の写真'; }, pick: '写真を選ぶ', change: '変更する', empty: 'まだ選んでいません', notImage: '写真（画像）のファイルを選んでください', tooBig: '写真のファイルが大きすぎます（20MB まで）。スマホの「サイズを小さく」などで送り直してください' },
    bigPrint: { label: 'この写真を大きくプリント', help: '大きくプリントする写真があると、通常より 1 週間ほど長くかかり、お急ぎ納品は選べません。' },
    banner: { label: '横幕', help: '黒板の代わりに大きな横幕でメッセージを伝えます。通常より 1 週間ほど長くかかります。' },
    bannerText: { label: '横幕のメッセージ', help: '15 文字までがおすすめです（それより長いと字が小さくなります）。', max: 30 },
    song: { label: 'バースデーソング', help: '演者がダンスの前に「ハッピーバースデー」を歌います（ウェディングソングではありません）。', sample: 'https://www.youtube.com/watch?v=j_klEy_bRkg&t=15s' },
    music: { label: '音楽を指定する', help: '動画の音楽を YouTube の好きな曲に変えます（約 30 秒）。' },
    musicUrl: { label: '曲の YouTube の URL', placeholder: 'https://www.youtube.com/watch?v=…' },
    musicStart: { label: '使い始める位置', help: '曲の何分何秒から流すか（終わりの位置は指定できません）。空欄なら最初から。', placeholder: '例）1:05' },
    voice: { label: '機械音声を消す', help: '動画では、読み上げメッセージを機械音声が先に読み、演者がまねして叫びます。この機械音声を編集で消し、演者の声だけにします。' },
    vertical: {
      label: '動画の向き',
      choices: [
        { value: 'h', prop: '横長のみ（通常）', label: '横長（通常）', addon: null },
        { value: 'v', prop: '縦長のみ', label: '縦長だけ', note: 'Instagram のリール・ストーリー向け', addon: 'verticalOnly' },
        { value: 'hv', prop: '横長＋縦長', label: '横長と縦長の両方', note: '両方を撮影します', addon: 'verticalBoth' }
      ]
    },
    // 納期（2026-10-22 から 3 択。お急ぎと翌日は同時に選べない）
    speed: {
      label: 'お届けの日',
      choices: [
        { value: 'normal', label: '通常', note: '2〜5 日でお届けします', addon: null },
        { value: 'rush', label: 'お急ぎ（翌々日）', note: '18 時までのご注文・ご入金で、翌々日中にお届けします', addon: 'rush' },
        { value: 'next', label: '翌日納品', note: '19 時までのご注文・ご入金で、翌日中にお届けします', addon: 'nextDay' }
      ],
      help: 'お急ぎ・翌日納品は、遅れた場合に全額返金します（天候などで撮影できない日もあるため）。'
    },
    rushOff: 'ビッグプリント・横幕を選ぶと、お急ぎ・翌日納品は選べません（1 週間ほど長くかかるため）。',
    editPack: { label: 'オープニング・エンディングと字幕を付ける（編集パック）', help: '最初と最後に見せ場とお祝いのメッセージを入れた編集を追加します。読み上げの言葉に日本語の字幕を付けます。元の動画もお届けします。',
      // 見本（Shopify のファイル。orderform/uploadEditPackSamples.js で上げた 720p、2026-10-21）
      samples: [['見本を見る（横）', 'https://cdn.shopify.com/videos/c/vp/f46dccb867a243ad95635aaa34a11cfd/f46dccb867a243ad95635aaa34a11cfd.HD-720p-4.5Mbps-98301079.mp4'], ['（縦）', 'https://cdn.shopify.com/videos/c/vp/fd26e115e36640d69592c47cdd8785ee/fd26e115e36640d69592c47cdd8785ee.HD-720p-4.5Mbps-98301745.mp4']] },
    sender: { label: '最後に入れる差出人（任意）', help: '例）たかしより、営業部一同。空欄なら差出人なしで終わります。', placeholder: '例）ゆうこより', max: 20 },
    // オープニングの赤い帯の言葉（2026-10-14 運営「お客さんが選べるのが良い」）。最初が既定。選択肢は 2026-10-21 運営の指定
    editPackHead: '編集パックの内容を決めてください',
    band: {
      label: 'オープニングのひとこと',
      help: 'オープニングで、画面の上の赤い帯に出る言葉です。',
      choices: ['ガチで祝いに来た!!', '本日の主役、登場!!', '祝!! 世界が見てるぞ'],
      custom: '自分で書く',
      placeholder: '例）祝！30歳!!',
      max: 14
    },
    total: '合計（税込）',
    submit: 'カートに追加する',
    submitting: 'カートに追加しています…',
    errorSummary: '赤く表示した項目を確かめてください',
    errorAdd: 'カートに追加できませんでした。通信の状態を確かめて、もう一度お試しください。'
  };

  function initialState() {
    return { blackboard: '', narration: '', print: 0, kiss: true, photos: [], bigPrint: 0, bigSel: [], banner: false, bannerText: '', song: false, music: false, musicUrl: '', musicStart: '', voice: false, vertical: 'h', rush: false, nextDay: false, editPack: false, sender: '', band: '', bandCustom: '' };
  }

  // 選択に応じて出す欄（HulkApps の条件と同じ: 写真の枚数 → アップロード欄・キス・ビッグプリント、音楽 → URL・開始、横幕 → 文、
  // ビッグプリントか横幕 → お急ぎを消す）
  function visibility(setKey, s) {
    var set = SETS[setKey] || SETS.standard;
    var bigCount = Array.isArray(s.bigSel) && s.bigSel.length ? s.bigSel.slice(0, s.print).filter(Boolean).length : (parseInt(s.bigPrint, 10) || 0);
    var longJob = (set.bigPrint && bigCount > 0) || (set.banner && s.banner);
    return {
      photos: s.print,
      kiss: s.print > 0,
      bigPrint: set.bigPrint && s.print > 0,
      bigPrintMax: set.bigPrint ? s.print : 0,
      banner: set.banner,
      bannerText: set.banner && s.banner,
      musicFields: s.music,
      senderField: !!s.editPack,
      bandCustom: !!s.editPack && s.band === 'custom',
      rush: set.rush && !longJob,
      rushBlockedByLongJob: set.rush && longJob
    };
  }

  // 表示条件で消えた選択を落とした状態（例: 写真を 0 枚に戻したらビッグプリントも 0）
  function normalize(setKey, s) {
    var set = SETS[setKey] || SETS.standard;
    var n = {};
    for (var k in s) n[k] = s[k];
    n.print = Math.max(0, Math.min(5, parseInt(n.print, 10) || 0));
    // 大きくする写真は写真ごとに選ぶ（bigSel）。古い呼び方（枚数 bigPrint だけ）は先頭からその枚数を選んだものとして読む
    var sel = Array.isArray(n.bigSel) && n.bigSel.length ? n.bigSel.slice(0, n.print).map(Boolean)
      : Array.apply(null, Array(n.print)).map(function (_, i) { return i < (parseInt(n.bigPrint, 10) || 0); });
    while (sel.length < n.print) sel.push(false);
    n.bigSel = set.bigPrint ? sel : sel.map(function () { return false; });
    n.bigPrint = n.bigSel.filter(Boolean).length;
    // 外したオプションの入力（横幕の文・曲の URL など）は消さない: 画面の欄には文字が残るので、消すと付け直したときに
    // 「欄に見えているのに未入力」になる。送る中身と入力チェックはオプションの有無で絞っている。
    if (!set.banner) n.banner = false;
    if (!visibility(setKey, n).rush) { n.rush = false; n.nextDay = false; }
    if (n.nextDay) n.rush = false;
    if (['h', 'v', 'hv'].indexOf(n.vertical) < 0) n.vertical = 'h';
    return n;
  }

  // 払う追加商品 { 種類: 数量 }（shopify/orderForm.js の expectedAddons と同じ結果になること）
  function addonsFor(setKey, s0) {
    var s = normalize(setKey, s0);
    var a = {};
    if (s.print > 0) a.print = s.print;
    if (s.bigPrint > 0) a.bigPrint = s.bigPrint;
    if (s.banner) a.banner = 1;
    if (s.song) a.song = 1;
    if (s.music) a.music = 1;
    if (s.voice) a.voice = 1;
    if (s.rush) a.rush = 1;
    if (s.nextDay) a.nextDay = 1;
    if (s.editPack) a.editPack = 1;
    if (s.vertical === 'v') a.verticalOnly = 1;
    if (s.vertical === 'hv') a.verticalBoth = 1;
    return a;
  }

  // 写真を送る順（元の枠番号の並び）。大きくする写真を先頭に並べる: 業者は「先頭から◯枚が大きい」で受け取る
  function photoOrder(setKey, s0) {
    var s = normalize(setKey, s0);
    var big = [], rest = [];
    for (var i = 1; i <= s.print; i++) (s.bigSel[i - 1] ? big : rest).push(i);
    return big.concat(rest);
  }

  function total(basePrice, setKey, s, prices) {
    var sum = Number(basePrice || 0);
    var a = addonsFor(setKey, s);
    for (var k in a) sum += a[k] * Number((prices[k] && prices[k].price) || 0);
    return sum;
  }

  // 本体の行の項目（写真のファイルは別に付ける）。選んだオプションだけ載せる。
  // 曲の URL: 「youtube.com/…」「youtu.be/…」のように https:// が無くても補う
  function musicUrlOf(v) {
    var t = String(v || '').trim();
    if (t && !/^https?:\/\//i.test(t) && /^(www\.|m\.|music\.)?(youtube\.com|youtu\.be)\//i.test(t)) t = 'https://' + t;
    return t;
  }

  function mainProperties(setKey, s0, unit) {
    var s = normalize(setKey, s0);
    var p = {};
    p[PROP.blackboard] = s.blackboard.trim();
    p[PROP.narration] = s.narration.trim();
    if (s.print > 0) { p[PROP.print] = full(s.print) + '枚'; p[PROP.kiss] = s.kiss ? 'あり' : 'なし'; }
    if (s.bigPrint > 0) p[PROP.bigPrint] = s.bigPrint === 1 ? '１枚目のみ' : '１～' + full(s.bigPrint) + '枚目';
    if (s.banner) { p[PROP.banner] = 'あり'; p[PROP.bannerText] = s.bannerText.trim(); }
    if (s.song) p[PROP.song] = 'あり';
    if (s.music) { p[PROP.music] = 'あり'; p[PROP.musicUrl] = musicUrlOf(s.musicUrl); p[PROP.musicStart] = s.musicStart.trim() || '最初から'; }
    if (s.voice) p[PROP.voice] = 'あり';
    if (s.rush) p[PROP.rush] = 'あり';
    if (s.nextDay) p[PROP.nextDay] = 'あり';
    if (s.editPack) {
      p[PROP.editPack] = 'あり';
      if (s.sender.trim()) p[PROP.sender] = s.sender.trim();
      p[PROP.editPackBand] = bandOf(s);
    }
    var v = TEXT.vertical.choices.filter(function (c) { return c.value === s.vertical; })[0];
    p[PROP.vertical] = v.prop;
    p._unit = unit;
    return p;
  }

  // オープニングの赤い帯の言葉。「自分で書く」は入力、空なら既定
  function bandOf(s) {
    if (s.band === 'custom') return String(s.bandCustom || '').trim() || TEXT.band.choices[0];
    return TEXT.band.choices.indexOf(s.band) >= 0 ? s.band : TEXT.band.choices[0];
  }

  function addonItems(setKey, s, unit, prices, productTitle) {
    var a = addonsFor(setKey, s);
    var items = [];
    var label = String(productTitle || '').replace(/★.*/, '') + '（' + s.blackboard.trim() + '）';
    for (var k in a) {
      if (!prices[k] || !prices[k].variantId) throw new Error('追加商品の設定がありません: ' + k);
      items.push({ id: Number(prices[k].variantId), quantity: a[k], properties: { '対象の動画': label, _unit: unit, _option: k } });
    }
    return items;
  }

  // 見た目の文字数（絵文字などを 1 文字と数える。JavaScript の length は 2 と数える）
  function charCount(t) { return Array.from(String(t == null ? '' : t)).length; }

  var HIRA_OK = /^[ぁ-ゖー　 、。！？!?ー〜～]*$/;
  var BOARD_BAD = /[^\p{L}\p{N}\s！？!?ー〜～、。・]/u;

  // 入力チェック。errors は送信を止める、warnings は止めずに知らせる（今のフォームも記号・ひらがなは止めていない）。
  function validate(setKey, s0, photoCount) {
    var s = normalize(setKey, s0);
    var errors = []; var warnings = [];
    if (!s.blackboard.trim()) errors.push({ field: 'blackboard', message: '黒板に書くメッセージを入力してください' });
    else if (charCount(s.blackboard.trim()) > TEXT.blackboard.max) errors.push({ field: 'blackboard', message: '黒板のメッセージは ' + TEXT.blackboard.max + ' 文字までです' });
    else if (BOARD_BAD.test(s.blackboard)) warnings.push({ field: 'blackboard', message: '「！」「？」以外の記号や絵文字は黒板に書けないことがあります' });
    if (!s.narration.trim()) errors.push({ field: 'narration', message: '読み上げメッセージを入力してください' });
    else if (charCount(s.narration.trim()) > TEXT.narration.max) errors.push({ field: 'narration', message: '読み上げメッセージは ' + TEXT.narration.max + ' 文字までです' });
    else if (!HIRA_OK.test(s.narration.trim())) warnings.push({ field: 'narration', message: 'ひらがな以外の文字があります。読み間違いを防ぐため、ひらがなでの入力をおすすめします' });
    if (s.print > 0 && (photoCount || 0) < s.print) errors.push({ field: 'photos', message: '写真を ' + s.print + ' 枚選んでください（いま ' + (photoCount || 0) + ' 枚）' });
    if (s.banner && !s.bannerText.trim()) errors.push({ field: 'bannerText', message: '横幕のメッセージを入力してください' });
    if (s.banner && charCount(s.bannerText.trim()) > TEXT.bannerText.max) errors.push({ field: 'bannerText', message: '横幕のメッセージは ' + TEXT.bannerText.max + ' 文字までです' });
    if (s.editPack && s.band === 'custom' && charCount(String(s.bandCustom || '').trim()) > TEXT.band.max) errors.push({ field: 'band', message: 'ひとことは ' + TEXT.band.max + ' 文字までです' });
    if (s.editPack && charCount(s.sender.trim()) > TEXT.sender.max) errors.push({ field: 'sender', message: '差出人は ' + TEXT.sender.max + ' 文字までです' });
    if (s.music && !/^https?:\/\/(www\.|m\.|music\.)?(youtube\.com|youtu\.be)\//i.test(musicUrlOf(s.musicUrl))) errors.push({ field: 'musicUrl', message: '曲の YouTube の URL を入力してください' });
    return { errors: errors, warnings: warnings };
  }

  function newUnitId() {
    var r = '';
    try { var b = new Uint8Array(6); (self.crypto || window.crypto).getRandomValues(b); for (var i = 0; i < b.length; i++) r += b[i].toString(16).padStart(2, '0'); }
    catch (e) { r = Math.random().toString(16).slice(2, 14); }
    return Date.now().toString(36) + '-' + r;
  }

  // 写真 1 枚の上限。Shopify はカートの添付で 20MB 前後を超えると受け付けない（27MB の PNG で失敗、16MB は通った。2026-10-12）
  var MAX_PHOTO_BYTES = 20 * 1024 * 1024;

  // 画像かどうか（accept="image/*" は選ぶ画面の絞り込みだけで、PDF なども選べてしまう）。type が空の端末は拡張子で見る
  function isImageFile(f) {
    if (!f) return false;
    if (f.type) return /^image\//.test(f.type);
    return /\.(jpe?g|png|gif|webp|heic|heif|bmp)$/i.test(f.name || '');
  }

  // ---- 画面（ブラウザだけ） ----------------------------------------------------------------
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function mount(container, config, deps) {
    deps = deps || {};
    var doFetch = deps.fetch || window.fetch.bind(window);
    var go = deps.navigate || function (url) { window.location.href = url; };
    var setKey = SETS[config.set] ? config.set : 'standard';
    var prices = config.addons || {};
    var price = function (k) { return yen((prices[k] && prices[k].price) || 0); };
    // 翌日納品・編集パックは追加商品があるときだけ出す（テーマを先に入れても、商品を作るまでは出ない）
    var has = function (k) { return !!(prices[k] && prices[k].variantId); };
    var state = initialState();
    var files = {}; // n -> File
    var submitBtn = document.getElementById(config.submitId || 'AddToCart');

    function toggleRow(key, label, priceKey, help, extra) {
      return '<label class="sof-opt"><input type="checkbox" data-k="' + key + '"><span class="sof-opt__main"><span class="sof-opt__label">' + esc(label) + '</span>' +
        (priceKey ? '<span class="sof-opt__price">+' + price(priceKey) + '</span>' : '') + '</span>' +
        (help ? '<span class="sof-help">' + esc(help) + (extra || '') + '</span>' : '') + '</label>';
    }

    var T = TEXT;
    container.innerHTML =
      '<div class="sof">' +
      '<p class="sof-intro">' + esc(T.intro) + '</p>' +
      '<div class="sof-field" data-f="blackboard"><label class="sof-label" for="sof-blackboard">' + esc(T.blackboard.label) + '<span class="sof-req">必須</span></label>' +
      '<p class="sof-help">' + esc(T.blackboard.help) + ' <a href="' + esc(T.examples.url) + '" target="_blank" rel="noopener">' + esc(T.examples.label) + '</a></p>' +
      '<input id="sof-blackboard" class="sof-input" type="text" data-k="blackboard" placeholder="' + esc(T.blackboard.placeholder) + '" autocomplete="off">' +
      '<div class="sof-count"><span data-count="blackboard">0</span> / ' + T.blackboard.max + '</div><p class="sof-msg" data-msg="blackboard"></p></div>' +

      '<div class="sof-field" data-f="narration"><label class="sof-label" for="sof-narration">' + esc(T.narration.label) + '<span class="sof-req">必須</span></label>' +
      '<p class="sof-help">' + esc(T.narration.help) + '</p>' +
      '<input id="sof-narration" class="sof-input" type="text" data-k="narration" placeholder="' + esc(T.narration.placeholder) + '" autocomplete="off">' +
      '<div class="sof-count"><span data-count="narration">0</span> / ' + T.narration.max + '</div><p class="sof-msg" data-msg="narration"></p></div>' +

      '<h3 class="sof-heading">' + esc(T.optionsHeading) + '</h3>' +

      '<div class="sof-opt sof-opt--stepper"><span class="sof-opt__main"><span class="sof-opt__label">' + esc(T.print.label) + '</span><span class="sof-opt__price">' + esc(T.print.unit) + ' +' + price('print') + '</span></span>' +
      '<span class="sof-help">' + esc(T.print.help) + '</span>' +
      '<span class="sof-stepper"><button type="button" data-step="print" data-d="-1" aria-label="減らす">−</button><output data-out="print">0 枚</output><button type="button" data-step="print" data-d="1" aria-label="増やす">＋</button></span></div>' +
      '<div class="sof-sub" data-show="photos"><p class="sof-help sof-big-note" data-show="bigPrint">' + esc(T.bigPrint.help) + '</p><div data-photos></div>' +
      '<label class="sof-check"><input type="checkbox" data-k="kiss" checked> ' + esc(T.kiss.label) + '</label>' +
      '<p class="sof-msg" data-msg="photos"></p></div>' +


      '<div data-show="banner">' + toggleRow('banner', T.banner.label, 'banner', T.banner.help) +
      '<div class="sof-sub" data-show="bannerText"><label class="sof-label" for="sof-bannerText">' + esc(T.bannerText.label) + '</label><p class="sof-help">' + esc(T.bannerText.help) + '</p>' +
      '<input id="sof-bannerText" class="sof-input" type="text" data-k="bannerText" autocomplete="off"><div class="sof-count"><span data-count="bannerText">0</span> / ' + T.bannerText.max + '</div><p class="sof-msg" data-msg="bannerText"></p></div></div>' +

      toggleRow('song', T.song.label, 'song', T.song.help, ' <a href="' + esc(T.song.sample) + '" target="_blank" rel="noopener">見本を見る</a>') +
      toggleRow('music', T.music.label, 'music', T.music.help) +
      '<div class="sof-sub" data-show="musicFields"><label class="sof-label" for="sof-musicUrl">' + esc(T.musicUrl.label) + '</label>' +
      '<input id="sof-musicUrl" class="sof-input" type="text" inputmode="url" autocapitalize="off" spellcheck="false" data-k="musicUrl" placeholder="' + esc(T.musicUrl.placeholder) + '"><p class="sof-msg" data-msg="musicUrl"></p>' +
      '<label class="sof-label" for="sof-musicStart">' + esc(T.musicStart.label) + '</label><p class="sof-help">' + esc(T.musicStart.help) + '</p>' +
      '<input id="sof-musicStart" class="sof-input sof-input--short" type="text" data-k="musicStart" placeholder="' + esc(T.musicStart.placeholder) + '"></div>' +
      toggleRow('voice', T.voice.label, 'voice', T.voice.help) +
      (has('editPack') ? toggleRow('editPack', T.editPack.label, 'editPack', T.editPack.help, T.editPack.samples.map(function (x) { return ' <a href="' + esc(x[1]) + '" target="_blank" rel="noopener">' + esc(x[0]) + '</a>'; }).join('')) +
      '<div class="sof-sub sof-sub--pack" data-show="senderField">' +
      '<p class="sof-subhead">' + esc(T.editPackHead) + '</p>' +
      '<span class="sof-label">' + esc(T.band.label) + '</span><p class="sof-help">' + esc(T.band.help) + '</p>' +
      '<div class="sof-bandpreview" aria-hidden="true"><span data-band-preview>' + esc(T.band.choices[0]) + '</span></div><div class="sof-choices">' +
      T.band.choices.concat(['custom']).map(function (c, i) {
        return '<label class="sof-choice"><input type="radio" name="sof-band" value="' + esc(c) + '"' + (i === 0 ? ' checked' : '') + '><span><b>' + esc(c === 'custom' ? T.band.custom : c) + '</b></span></label>';
      }).join('') + '</div>' +
      '<div data-show="bandCustom"><input id="sof-bandCustom" class="sof-input" type="text" data-k="bandCustom" placeholder="' + esc(T.band.placeholder) + '" autocomplete="off">' +
      '<div class="sof-count"><span data-count="bandCustom">0</span> / ' + T.band.max + '</div></div><p class="sof-msg" data-msg="band"></p>' +
      '<label class="sof-label" for="sof-sender">' + esc(T.sender.label) + '</label><p class="sof-help">' + esc(T.sender.help) + '</p>' +
      '<input id="sof-sender" class="sof-input" type="text" data-k="sender" placeholder="' + esc(T.sender.placeholder) + '" autocomplete="off"><div class="sof-count"><span data-count="sender">0</span> / ' + T.sender.max + '</div><p class="sof-msg" data-msg="sender"></p>' +'</div>' : '') +

      '<div class="sof-field"><span class="sof-label">' + esc(T.vertical.label) + '</span><div class="sof-choices">' +
      T.vertical.choices.map(function (c) {
        return '<label class="sof-choice"><input type="radio" name="sof-vertical" value="' + c.value + '"' + (c.value === 'h' ? ' checked' : '') + '><span><b>' + esc(c.label) + '</b>' +
          (c.addon ? ' <span class="sof-opt__price">+' + price(c.addon) + '</span>' : '') + (c.note ? '<small>' + esc(c.note) + '</small>' : '') + '</span></label>';
      }).join('') + '</div></div>' +

      '<div class="sof-field" data-show="rush"><span class="sof-label">' + esc(T.speed.label) + '</span><div class="sof-choices">' +
      T.speed.choices.filter(function (c) { return !c.addon || has(c.addon); }).map(function (c) {
        return '<label class="sof-choice"><input type="radio" name="sof-speed" value="' + c.value + '"' + (c.value === 'normal' ? ' checked' : '') + '><span><b>' + esc(c.label) + '</b>' +
          (c.addon ? ' <span class="sof-opt__price">+' + price(c.addon) + '</span>' : '') + (c.note ? '<small>' + esc(c.note) + '</small>' : '') + '</span></label>';
      }).join('') + '</div><p class="sof-help">' + esc(T.speed.help) + '</p></div>' +
      '<p class="sof-help sof-note" data-show="rushBlockedByLongJob">' + esc(T.rushOff) + '</p>' +

      '<div class="sof-total"><span>' + esc(T.total) + '</span><b data-total></b></div>' +
      '<p class="sof-msg sof-msg--summary" data-msg="summary" role="alert"></p>' +
      '</div>';

    var q = function (sel) { return container.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(container.querySelectorAll(sel)); };

    function renderPhotos() {
      var box = q('[data-photos]');
      var have = box.querySelectorAll('.sof-photo').length;
      for (var n = have + 1; n <= state.print; n++) {
        var row = document.createElement('div');
        row.className = 'sof-photo';
        row.innerHTML = '<label class="sof-photo__pick"><span class="sof-photo__thumb" data-photo-thumb="' + n + '"></span><span class="sof-photo__text"><b>' + esc(T.photo.label(n)) + '</b>' +
          '<span class="sof-photo__name" data-photo-name="' + n + '">' + esc(T.photo.empty) + '</span></span><span class="sof-photo__btn" data-photo-btn="' + n + '">' + esc(T.photo.pick) + '</span>' +
          '<input type="file" accept="image/*" data-photo="' + n + '"></label>' +
          '<label class="sof-photo__big" data-big-row><input type="checkbox" data-big="' + n + '"> ' + esc(T.bigPrint.label) + ' <span class="sof-opt__price">+' + price('bigPrint') + '</span></label>';
        box.appendChild(row);
      }
      var bigOn = visibility(setKey, state).bigPrint;
      qa('.sof-photo').forEach(function (row, i) {
        row.hidden = i >= state.print;
        var big = row.querySelector('[data-big-row]');
        big.hidden = !bigOn;
        big.querySelector('input').checked = !!state.bigSel[i];
        row.classList.toggle('is-big', bigOn && !!state.bigSel[i]);
      });
    }

    function render() {
      state = normalize(setKey, state);
      var v = visibility(setKey, state);
      qa('[data-show]').forEach(function (el) {
        var key = el.getAttribute('data-show');
        var on = v[key];
        el.hidden = !(typeof on === 'number' ? on > 0 : on);
      });
      q('[data-out="print"]').textContent = state.print + ' 枚';
      renderPhotos();
      ['blackboard', 'narration', 'bannerText', 'sender', 'bandCustom'].forEach(function (k) {
        var c = q('[data-count="' + k + '"]'); if (!c) return;
        var n = charCount(state[k]);
        c.textContent = n;
        c.parentNode.classList.toggle('is-over', n > (T[k] || T.band).max);
      });
      var bp = q('[data-band-preview]'); if (bp) bp.textContent = bandOf(state);
      var sp = state.nextDay ? 'next' : state.rush ? 'rush' : 'normal';
      qa('input[name="sof-speed"]').forEach(function (r) { r.checked = r.value === sp; });
      q('[data-total]').textContent = yen(total(config.price, setKey, state, prices));
    }

    function showMessages(result) {
      qa('[data-msg]').forEach(function (m) { m.textContent = ''; m.className = m.className.replace(/ ?is-(error|warn)/g, ''); });
      qa('.sof-field, .sof-sub').forEach(function (f) { f.classList.remove('is-error'); });
      result.warnings.forEach(function (w) { var m = q('[data-msg="' + w.field + '"]'); if (m) { m.textContent = w.message; m.classList.add('is-warn'); } });
      result.errors.forEach(function (e) {
        var m = q('[data-msg="' + e.field + '"]');
        if (m) { m.textContent = e.message; m.classList.remove('is-warn'); m.classList.add('is-error'); var f = m.closest('.sof-field, .sof-sub'); if (f) f.classList.add('is-error'); }
      });
    }

    container.addEventListener('input', function (ev) {
      var k = ev.target.getAttribute('data-k');
      if (k && ev.target.type !== 'checkbox') { state[k] = ev.target.value; render(); if (k === 'blackboard' || k === 'narration') showMessages({ errors: [], warnings: validate(setKey, state, Object.keys(files).length).warnings }); }
    });
    container.addEventListener('change', function (ev) {
      var t = ev.target;
      var k = t.getAttribute('data-k');
      if (k && t.type === 'checkbox') state[k] = t.checked;
      if (t.name === 'sof-vertical') state.vertical = t.value;
      if (t.name === 'sof-band') state.band = t.value;
      if (t.name === 'sof-speed') { state.rush = t.value === 'rush'; state.nextDay = t.value === 'next'; }
      var bi = t.getAttribute('data-big');
      if (bi) { var sel = state.bigSel.slice(); sel[Number(bi) - 1] = t.checked; state.bigSel = sel; }
      var n = t.getAttribute('data-photo');
      if (n) {
        var f = t.files && t.files[0];
        var bad = f && (!isImageFile(f) ? T.photo.notImage : f.size > MAX_PHOTO_BYTES ? T.photo.tooBig : null);
        if (bad) { t.value = ''; f = null; var pm = q('[data-msg="photos"]'); pm.textContent = bad; pm.className = 'sof-msg is-error'; }
        if (f) files[n] = f; else delete files[n];
        q('[data-photo-name="' + n + '"]').textContent = files[n] ? files[n].name : T.photo.empty;
        q('[data-photo-btn="' + n + '"]').textContent = files[n] ? T.photo.change : T.photo.pick;
        var thumb = q('[data-photo-thumb="' + n + '"]');
        thumb.style.backgroundImage = files[n] && window.URL ? 'url(' + URL.createObjectURL(files[n]) + ')' : '';
        thumb.classList.toggle('is-set', !!files[n]);
      }
      render();
    });
    container.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-step]');
      if (!b) return;
      var k = b.getAttribute('data-step');
      state[k] = (parseInt(state[k], 10) || 0) + Number(b.getAttribute('data-d'));
      render();
    });

    function photoCount() { var c = 0; for (var n = 1; n <= state.print; n++) if (files[n]) c++; return c; }

    var busy = false;
    var idleLabel = submitBtn ? submitBtn.textContent : T.submit;
    // 送信中の状態を解く。カートに移ったあと「戻る」でページが復元される（iPhone の Safari など）と、
    // 送信中のままボタンが押せなくなるので、復元のときにも呼ぶ
    function resetBusy() {
      busy = false;
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = idleLabel; }
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) resetBusy(); });
    function submit(ev) {
      if (ev) ev.preventDefault();
      if (busy) return;
      state = normalize(setKey, state);
      var result = validate(setKey, state, photoCount());
      showMessages(result);
      var summary = q('[data-msg="summary"]');
      if (result.errors.length) {
        summary.textContent = T.errorSummary; summary.classList.add('is-error');
        var first = q('.is-error'); if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var unit = newUnitId();
      var addons;
      try { addons = addonItems(setKey, state, unit, prices, config.title); }
      catch (e) { summary.textContent = T.errorAdd; summary.classList.add('is-error'); if (window.console) console.error(e); return; }
      busy = true;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = T.submitting; }
      var fd = new FormData();
      fd.append('id', String(config.variantId));
      fd.append('quantity', '1');
      var props = mainProperties(setKey, state, unit);
      Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
      photoOrder(setKey, state).forEach(function (slot, i) { fd.append('properties[' + PROP.photo(i + 1) + ']', files[slot]); });
      var mainKey = null;
      doFetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error('main ' + r.status); return r.json(); })
        .then(function (item) {
          mainKey = item && item.key;
          if (!addons.length) return null;
          return doFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: addons }) })
            .then(function (r) { if (!r.ok) throw new Error('addons ' + r.status); });
        })
        .then(function () { go(config.cartUrl || '/cart'); })
        .catch(function () {
          // 追加商品が入らなかったら本体を取り消す（料金の食い違いを残さない）
          var undo = mainKey ? doFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: mainKey, quantity: 0 }) }).catch(function () {}) : Promise.resolve();
          return undo.then(function () {
            resetBusy();
            summary.textContent = T.errorAdd; summary.classList.add('is-error');
          });
        });
    }

    var form = container.closest('form');
    if (form) form.addEventListener('submit', submit);
    else if (submitBtn) submitBtn.addEventListener('click', submit);
    render();
    return { state: function () { return state; }, submit: submit, resetBusy: resetBusy };
  }

  return { charCount: charCount, SETS: SETS, PROP: PROP, TEXT: TEXT, initialState: initialState, visibility: visibility, normalize: normalize, photoOrder: photoOrder, bandOf: bandOf, musicUrlOf: musicUrlOf, isImageFile: isImageFile, addonsFor: addonsFor, total: total, mainProperties: mainProperties, addonItems: addonItems, validate: validate, mount: mount };
});
